export interface DeliveryAddressDraft {
  address: string;
  town: string;
  village: string;
  county: string;
}

export const emptyAddressDraft: DeliveryAddressDraft = {
  address: '',
  town: '',
  village: '',
  county: '',
};

/** Browser-side check for an empty form; the server re-checks with the upload's rules. */
export const isBlankAddress = (draft: DeliveryAddressDraft) =>
  Object.values(draft).every((value) => !value.trim());
